import PropTypes from 'prop-types';

import RepairRequestLinesTable from '#/modules/crmMgmt/aftersales/repairRequest/components/RepairRequestLinesTable';
import RepairRequestMainInfoCard from '#/modules/crmMgmt/aftersales/repairRequest/components/RepairRequestMainInfoCard';
import CreateEditReferenceSection from '#/modules/infra/layout/CreateEditReferenceSection';

/** 報修單編輯頁右欄：GET detail 唯讀快照（靜態，儲存 refetch 才更新）。 */
const RepairRequestEditReferenceSections = ({ detail }) => {
  if (!detail) {
    return null;
  }

  return (
    <>
      <CreateEditReferenceSection title="單據快照（唯讀）">
        <RepairRequestMainInfoCard detail={detail} compact nested />
      </CreateEditReferenceSection>
      <CreateEditReferenceSection title="報修明細" flush>
        <RepairRequestLinesTable lines={detail?.lines ?? []} />
      </CreateEditReferenceSection>
    </>
  );
};

RepairRequestEditReferenceSections.propTypes = {
  detail: PropTypes.object,
};

export default RepairRequestEditReferenceSections;
